import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _slicedToArray from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography } from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
var useStyles = makeStyles(function (theme) {
  return {
    overlay: {
      zIndex: theme.zIndex.modal
    },
    dialogPaper: {
      textAlign: "center",
      padding: theme.spacing(3),
      maxWidth: "400px",
      width: "90%"
    },
    icon: {
      fontSize: "4rem",
      color: theme.palette.warning.main,
      marginBottom: theme.spacing(2),
      display: "block",
      margin: "0 auto"
    },
    title: {
      paddingBottom: theme.spacing(1)
    },
    content: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }
  };
});
var IdleOverlay = function IdleOverlay(_ref) {
  var _ref$idleTimeoutSecon = _ref.idleTimeoutSeconds,
    idleTimeoutSeconds = _ref$idleTimeoutSecon === void 0 ? 300 : _ref$idleTimeoutSecon,
    _ref$countDownSeconds = _ref.countDownSeconds,
    countDownSeconds = _ref$countDownSeconds === void 0 ? 60 : _ref$countDownSeconds,
    children = _ref.children;
  if (window.self !== window.top) {
    // NOTE: don't show the idle overlay in iframes
    return React.createElement(React.Fragment, null, children);
  }
  var classes = useStyles();
  var _useAuth = useAuth0(),
    loginWithRedirect = _useAuth.loginWithRedirect;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showIdleDialog = _useState2[0],
    setShowIdleDialog = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoggedOut = _useState4[0],
    setIsLoggedOut = _useState4[1];
  var _useState5 = useState(countDownSeconds),
    _useState6 = _slicedToArray(_useState5, 2),
    timeRemaining = _useState6[0],
    setTimeRemaining = _useState6[1];
  var lastActivityTime = useRef(Date.now());
  var ignoreUpdatingActivityTime = useRef(false);
  var logout = function logout() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch("https://".concat(window.appConfig.auth0Config.domain, "/oidc/logout"), {
                method: "GET",
                mode: "no-cors",
                credentials: "include"
              });
            case 3:
              _context.next = 8;
              break;
            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              console.error("Failed to log out", _context.t0);
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));
  };
  useEffect(function () {
    var updateUserActivityTimer = function updateUserActivityTimer() {
      if (ignoreUpdatingActivityTime.current) {
        return;
      }
      lastActivityTime.current = Date.now();
    };
    var activityEvents = ["mousemove", "keydown", "scroll", "click", "touchstart"];
    activityEvents.forEach(function (event) {
      window.addEventListener(event, updateUserActivityTimer);
    });
    return function () {
      activityEvents.forEach(function (event) {
        window.removeEventListener(event, updateUserActivityTimer);
      });
    };
  }, []);
  useEffect(function () {
    var loggedOut = false;
    var interval = setInterval(function () {
      var secondsIdle = Math.floor((Date.now() - lastActivityTime.current) / 1000);
      if (secondsIdle >= idleTimeoutSeconds + countDownSeconds && !loggedOut) {
        loggedOut = true;
        setIsLoggedOut(true);
        setShowIdleDialog(true);
        logout();
        clearInterval(interval);
      } else if (secondsIdle >= idleTimeoutSeconds) {
        ignoreUpdatingActivityTime.current = true;
        setShowIdleDialog(true);
        setTimeRemaining(countDownSeconds - (secondsIdle - idleTimeoutSeconds));
      }
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, []);
  if (!showIdleDialog) {
    return React.createElement(React.Fragment, null, children);
  }
  var handleStayLoggedIn = function handleStayLoggedIn() {
    setShowIdleDialog(false);
    ignoreUpdatingActivityTime.current = false;
    lastActivityTime.current = Date.now();
  };
  var handleLogInAgain = function handleLogInAgain() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!loginWithRedirect) {
                _context2.next = 3;
                break;
              }
              _context2.next = 3;
              return loginWithRedirect({
                appState: {
                  targetUrl: window.location
                }
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };
  return React.createElement(Dialog, {
    open: showIdleDialog,
    disableBackdropClick: true,
    disableEscapeKeyDown: true,
    className: classes.overlay,
    classes: {
      paper: classes.dialogPaper
    }
  }, React.createElement(DialogTitle, {
    className: classes.title
  }, React.createElement(AccessTimeIcon, {
    className: classes.icon
  }), React.createElement(Typography, {
    variant: "h5"
  }, "You're Inactive")), React.createElement(DialogContent, {
    className: classes.content
  }, isLoggedOut ? React.createElement(DialogContentText, null, "Your session has been logged out due to inactivity.") : React.createElement(DialogContentText, null, "You will be logged out in ", timeRemaining, " seconds due to inactivity.")), React.createElement(DialogActions, null, isLoggedOut ? React.createElement(Button, {
    onClick: handleLogInAgain,
    color: "primary",
    variant: "contained"
  }, "Log In") : React.createElement(Button, {
    onClick: handleStayLoggedIn,
    color: "primary",
    variant: "contained"
  }, "Continue Working")));
};
export default IdleOverlay;